export default {
	data(){
		return {
			tableGBoptions: { 
				options: {editar: 'Editar Centro de Trabajo', inactivar: 'Inactivar Centro de Trabajo'},
				modals: []
			},

			tableGBSearch: ['datos_contacto/name'],
			
			tableGBItems: [				
				{
					thead: { th: 'Documento', sort: null, sortTable: 'datos_contacto/documento'},
					tbody: { td: ['list_documento/name','datos_contacto/documento'],}
				},			
				{
					thead: { th: 'Razón', sort: null, sortTable: 'datos_contacto/name'},
					tbody: { td: ['datos_contacto/name'],}
				},
				{
					thead: { th: 'Teléfonos', },
					tbody: { td: ['datos_contacto/telefonos'],}
				},
				{
					thead: { th: 'Email', },
					tbody: { td: ['datos_contacto/email'],}
				},
			]			
		}
	},
}